import {memo} from 'react'
import {Outlet} from 'react-router'
import {Dashboard} from './Dashboard'

export const DashboardOutlet = memo(() => {
  return <Dashboard>
    <Outlet/>
  </Dashboard>
})
